import React, { Component } from 'react';
import { connect } from 'react-redux';
import Truncate from 'react-truncate';
import { t } from 'i18next';
import { getOnboardingState } from '../../../store/selectors';
import {
  showProgressBar,
  getUserData,
  getCurrentUserId,
} from '../../../store/actions';
import CareerOneStop from '../../utility/api/onestop/CareerOneStop';

import CareerChoiceBullets from './CareerChoiceBullets';
import { fireGTM } from '../../../gtm/gtmUtil';
import { degreePairingPage_GTM } from '../../../gtm/datalayers/degreePairingDataLayers.json';
import EarningCapacity from '../../utility/modal/careers/EarningCapacity';

// Expands the career info displayed in the career tab
class ExpandInfoLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabExpanded: false,
      expandOrCloseText: 'Expand Information',
      expandInfoTextPrimary: props.tenant.primary,
      lines: 2,
      showStateInfo: false,
    };
    this.showCareerCardText = this.showCareerCardText.bind(this);
  }

  async componentDidMount() {
    if (Object.values(this.props.onboarding.userData).length === 0) {
      const userId = await this.props.getCurrentUserId(
        this.props.auth.jwtToken
      );

      await this.props.getUserData(userId, this.props.auth.jwtToken);
    }

    if (
      !!this.props.onboarding.userData &&
      this.props.onboarding.userData.user.country === 'United States' &&
      this.props.tenant.name !== 'Baobab'
    ) {
      this.setState({
        showStateInfo: true,
      });
    }
  }

  showCareerCardText() {
    const tempExpandInfoGTM = Object.assign(
      {},
      degreePairingPage_GTM.expandInfo
    );

    tempExpandInfoGTM.section =
      this.props.onboarding.careerChoices[this.props.tabNumber].titleEn;
    fireGTM(tempExpandInfoGTM);

    if (!this.state.tabExpanded) {
      this.setState({ expandOrCloseText: 'Close' });
    } else {
      this.setState({
        expandOrCloseText: 'Expand Information',
      });
    }

    this.props.showProgressBar({
      ...this.props.onboarding.careerCardsExpanded,
      [this.props.tabNumber]:
        !this.props.onboarding.careerCardsExpanded[this.props.tabNumber],
    });

    this.setState((prevState) => ({
      tabExpanded: !prevState.tabExpanded,
    }));
  }

  careerInfoLoading = () => {
    return null;
  };

  render() {
    const { lines, tabExpanded } = this.state;

    return (
      <div className="expand-info-text-container">
        <p className="expand-info-short-text">
          <Truncate lines={!tabExpanded && lines} ellipsis={<span>...</span>}>
            {
              this.props.onboarding.careerChoices[this.props.tabNumber]
                .description
            }
          </Truncate>
        </p>
        <ul className="collapse-list">
          <li>
            <input
              className="collapse-open"
              type="checkbox"
              id={`collapse-${this.props.tabNumber}`}
            />
            {/* Display the bullet list tasks for each career here along with average pay and job openings */}
            <div className="collapse-panel">
              <div className="collapse-inner">
                <ol>
                  <>
                    <CareerChoiceBullets
                      color={this.props.tenant.primary}
                      cardNumber={this.props.tabNumber}
                    />
                    {this.state.showStateInfo && (
                      <CareerOneStop
                        tenant={this.props.tenant}
                        careerInfoLoading={this.careerInfoLoading}
                        user={this.props.onboarding.userData.user}
                        career={
                          this.props.onboarding.careerChoices[
                            this.props.tabNumber
                          ]
                        }
                        modalStyling={false}
                        setParentOnClick={this.props.setParentOnClick}
                      />
                    )}
                    {this.props.tenant.name === 'Baobab' && (
                      <EarningCapacity
                        career={
                          this.props.onboarding.careerChoices[
                            this.props.tabNumber
                          ]
                        }
                      />
                    )}
                  </>
                </ol>
              </div>
            </div>
            <label
              className={`collapse-btn ${this.state.tabExpanded}`}
              htmlFor={`collapse-${this.props.tabNumber}`}
              onClick={this.showCareerCardText}
              role="button"
              onKeyPress={this.showCareerCardText}
              style={{ color: this.state.expandInfoTextPrimary }}
              aria-label={`${
                this.state.expandOrCloseText === 'Close' ? 'close' : 'expand'
              } information about ${
                this.props.onboarding.careerChoices[this.props.tabNumber]
                  .titleEn
              }`}
              tabIndex="0"
            >
              {t(this.state.expandOrCloseText, { context: 'action' })}
            </label>
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const auth = state.auth;

  return { onboarding, auth };
};

export default connect(mapStateToProps, {
  getOnboardingState,
  getUserData,
  showProgressBar,
  getCurrentUserId,
})(ExpandInfoLink);
